import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminFormsManager.css";

const AdminFormsManager = () => {
  const [forms, setForms] = useState([]);

  // ✅ FETCH DATA
  const fetchForms = async () => {
    try {
      const res = await axios.get(`/api/forms`);
      setForms(res.data);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchForms();
  }, []);

  // ✅ DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this file?")) return;

    try {
      await axios.delete(`/api/forms/${id}`);
      fetchForms();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // ✅ DOWNLOAD
  const handleDownload = async (file) => {
    try {
      const res = await axios.get(`${BASE_URL}/uploads/forms/${file}`, {
        responseType: "blob",
      });
  
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file); // File name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  // ✅ PRINT
  const handlePrint = (file) => {
    const url = `${BASE_URL}/uploads/forms/${file}`;
    const win = window.open(url, "_blank");

    if (win) {
      win.onload = () => {
        win.focus();
        win.print();
      };
    }
  };

  return (
    <div className="adm-manager">
      <h2>Admission Forms (PDF Records)</h2>

      <div className="table-wrapper">
        <table className="adm-table">
          <thead>
            <tr>
              {/* <th>ID</th> */}
              <th>Student Name</th>
              <th>File</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {forms.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No Records Found
                </td>
              </tr>
            ) : (
              forms.map((item) => (
                <tr key={item.id}>
                  {/* <td>{item.id}</td> */}
                  <td>{item.student_name}</td>
                  <td className="file-name">{item.pdf_file}</td>
                  <td>
                      {new Date(item.created_at).toLocaleDateString("en-GB", {
                        timeZone: "Asia/Kolkata",
                      })}
                  </td>
                  <td className="actions">
                    <button
                      className="btn print"
                      onClick={() => handlePrint(item.pdf_file)}
                    >
                      Print
                    </button>

                    <button
                      className="btn download"
                      onClick={() => handleDownload(item.pdf_file)}
                    >
                      Download
                    </button>

                    <button
                      className="btn delete"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminFormsManager;